import { AutocompleteInput, Create, Edit, ReferenceInput, SimpleForm } from "react-admin";
import { FileInput } from "../fileinputs/eventFileUpload";

export function ContestSubmissionEdit(props) {

    return (
        <Edit {...props}>
            <SimpleForm>
                <ReferenceInput source="contestId" reference="contest">
                    <AutocompleteInput optionText={"name"} filterToQuery={searchText => ({ name: searchText })} />
                </ReferenceInput>
                <ReferenceInput source="childId" reference="child">
                    <AutocompleteInput optionText={"name"} filterToQuery={searchText => ({ name: searchText })} />
                </ReferenceInput>
                <FileInput source="files" title="Uploaded Files" route="contestSubmission/upload"  edit add/>

            </SimpleForm>
        </Edit>
    )
}





















